module.exports = __webpack_public_path__ + "img/image1.2.1.747738b5.png";